<button *ngIf="displayMode === 'button'"
        data-cy="ChatBoxSelecteerFunctieKnop"
        class="chatter-modal-button"
        (click)="open()">
  {{buttonLabel}}
</button>

<a class="chatter-modal-text" (click)="open()" *ngIf="displayMode === 'text'">
  <p>
    {{buttonLabel}}
  </p>
</a>
